var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChargerPinHighPowerSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 36,
    viewBox: "0 0 26 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_644_7613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9219 25.5261C19.7179 25.5261 25.2272 19.9712 25.2272 13.119C25.2272 6.26675 19.7179 0.711914 12.9219 0.711914C6.12594 0.711914 0.616699 6.26675 0.616699 13.119C0.616699 19.9712 6.12594 25.5261 12.9219 25.5261Z",
    fill: "#142C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9963 2.14082e-06C9.54877 0.00198845 6.24313 1.38423 3.80607 3.84287C1.36901 6.30151 -5.62859e-07 9.6353 0 13.1113C0 20.3488 12.9963 36 12.9963 36C12.9963 36 26.0074 20.3488 26.0074 13.1113C26.0074 11.3889 25.6708 9.68335 25.0169 8.09212C24.3629 6.50089 23.4044 5.05517 22.1961 3.83758C20.9878 2.61998 19.5534 1.65436 17.9749 0.995892C16.3963 0.337427 14.7046 -0.000982109 12.9963 2.14082e-06ZM12.9963 24.1024C10.8382 24.1039 8.72818 23.4599 6.93318 22.2519C5.13819 21.044 3.7389 19.3263 2.91236 17.3163C2.08582 15.3062 1.86917 13.0942 2.28983 10.96C2.71049 8.82578 3.74956 6.86533 5.27555 5.32671C6.80155 3.78809 8.74589 2.74042 10.8626 2.31628C12.9793 1.89214 15.1732 2.11058 17.1667 2.94396C19.1602 3.77734 20.8638 5.18821 22.0618 6.99806C23.2599 8.80791 23.8986 10.9354 23.8971 13.1113C23.8971 14.5547 23.6152 15.9839 23.0673 17.3174C22.5195 18.6509 21.7166 19.8626 20.7043 20.8832C19.6921 21.9038 18.4904 22.7134 17.1679 23.2657C15.8453 23.8181 14.4278 24.1024 12.9963 24.1024Z",
    fill: "#142C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5941 7.05029L13.0856 11.4482L17.2988 11.4557L13.0039 19.1727H11.2279L12.7958 14.4376L9.15479 14.4451L11.5177 7.05029H14.5941Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_644_7613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargerPinHighPowerSelected);
export default __webpack_public_path__ + "static/media/charger-pin-high-power-selected.15b80c1e39d58997510a5dc1c602f6d2.svg";
export { ForwardRef as ReactComponent };